<div class="component-container {{ !isContractSaved && !isContractDirty ? 'contract-not-saved' : ''}}">
  <mat-card class="contract-card w-full">
    <div class="heading-section bold-text">
      <div
        *ngIf="sessionNumber >= 4"
        class="week-number bold-text"
      >
        Week {{ weekNumber }}
      </div>
      <div class="page-title bold-text"> Weekly Goals & Contract </div>
      <div
        *ngIf="sessionNumber >= 4"
        class="date-section bold-text"
      >
        {{ weekStartDate | date: "mediumDate" }} -
        {{ weekEndDate | date: "mediumDate" }}
      </div>
    </div>
    <hr class="hr w-full" />
    <ng-container *ngIf="sessionNumber < 4">
      <div
        class="no-contracts bold-text flex flex-row justify-center items-center"
      >
        Contracts currently unavailable.
      </div>
    </ng-container>
    <ng-container *ngIf="sessionNumber >= 4">
      <div class="declaration-text bold-text">
        By completing this contract, I
        <span class="participant-name">
          {{ contractDetails?.participantName }}
        </span>
        commit to:
      </div>
      <div class="goals-section sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]">
        <div class="title bold-text underline"> My Weekly Goals: </div>
        <!--      RED LIGHT GOAL SECTION-->
        <div
          *ngIf="sessionNumber >= 4"
          class="red-light-goal flex flex-row justify-start items-start"
        >
          <app-icon
            class="rl-icon"
            svgIcon="red-light"
          ></app-icon>
          <div
            class="goal-text flex flex-col justify-start items-start gap-[1.2rem]"
          >
            <div class="w-full inline">
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['rlGoal']"
                [parentFormGroup]="form"
                class="input inline-block"
                controlName="rlGoal"
                type="small"
              ></app-number-input>
              red light food servings or fewer this week.
            </div>
            <div
              *ngIf="contractDetails?.recommendedRLGoal"
              class="flex flex-row justify-start items-center italic"
            >
              Suggested goal range:
              {{
                contractDetails.recommendedRLGoal.min
                  ? contractDetails.recommendedRLGoal.min + " to "
                  : ""
              }}
              {{ contractDetails.recommendedRLGoal.max }} red light food servings.
            </div>
          </div>
        </div>
        <!--      PHYSICAL ACTIVITY GOAL SECTION-->
        <div
          *ngIf="sessionNumber >= 9"
          class="physical-activity-goal flex flex-row justify-start items-start"
        >
          <app-icon
            class="pa-icon"
            svgIcon="physical-activity"
          ></app-icon>
          <div
            class="goal-text flex flex-col justify-start items-start gap-[1.2rem]"
          >
            <div class="inline w-full text-wrap align-middle">
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['paGoalDay']"
                [parentFormGroup]="form"
                class="input inline-block"
                controlName="paGoalDay"
                type="small"
              />
              days this week, earning at least
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['paGoalPoints']"
                [parentFormGroup]="form"
                class="input inline-block pa-goals-input"
                controlName="paGoalPoints"
                type="small"
                [showNumberSeparator]="true"
              />
              physical activity points each day.
            </div>
            <div
              *ngIf="contractDetails?.recommendedPAGoal"
              class="flex flex-row justify-start items-center italic"
            >
              Suggested goal range:
              {{
                contractDetails.recommendedPAGoal.minDays
                  ? contractDetails.recommendedPAGoal.minDays + " to "
                  : ""
              }}
              {{ contractDetails.recommendedPAGoal.maxDays }} days of at least
              {{
                contractDetails.recommendedPAGoal.minPoints
                  ? (contractDetails.recommendedPAGoal.minPoints | number) +
                    " to "
                  : ""
              }}
              {{ contractDetails.recommendedPAGoal.maxPoints | number }}
              physical activity points
            </div>
          </div>
        </div>
        <!--      SCREEN TIME GOAL SECTION-->
        <div
          *ngIf="sessionNumber >= 17"
          class="screen-time-goal flex flex-row justify-start items-start"
        >
          <app-icon
            class="st-icon"
            svgIcon="screen-time"
          />
          <div
            class="goal-text flex flex-col justify-start items-start gap-[1.2rem]"
          >
            <div class="w-full inline">
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['stGoalHr']"
                [parentFormGroup]="form"
                class="input inline-block"
                controlName="stGoalHr"
                type="small"
              />
              hours
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['stGoalMin']"
                [parentFormGroup]="form"
                class="input inline-block"
                controlName="stGoalMin"
                type="small"
              />
              <div
                *ngIf="errorMessages['stGoalMin']"
                class="text-red-600 text-xs mt-1"
              >
                {{ errorMessages["stGoalMin"] }}
              </div>
              minutes or less of screen time this week.
            </div>
            <div
              *ngIf="contractDetails?.recommendedSTGoal"
              class="flex flex-row justify-start items-center italic"
            >
              Suggested goal range:
              {{
                contractDetails.recommendedSTGoal.min
                  ? (contractDetails.recommendedSTGoal.min | hrAndMin) + " to "
                  : ""
              }}
              {{ contractDetails.recommendedSTGoal.max | hrAndMin }}
            </div>
          </div>
        </div>
      </div>
      <div class="strategy-section sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]">
        <div class="title bold-text">
          I will use the following strategies to help me achieve my weekly goals
          (list 1-3 more):
        </div>
        <div class="strategy-row flex row justify-center items-center">
          <div class="w-[5%] bullet"> &#9679; </div>
          <span class="w-[95%] fixed-strategy">
            I will journal or e-journal every day.
          </span>
        </div>
        <div class="strategy-row flex row justify-center items-center">
          <div class="w-[5%] bullet"> &#9679; </div>
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['strategy1']"
            [parentFormGroup]="form"
            class="w-[95%] strategy-input"
            controlName="strategy1"
            placeholder="Type here"
            type="small"
          ></app-text-input>
        </div>
        <div class="strategy-row flex row justify-center items-center">
          <div class="w-[5%] bullet"> &#9679; </div>
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['strategy2']"
            [parentFormGroup]="form"
            class="w-[95%] strategy-input"
            controlName="strategy2"
            placeholder="Type here"
            type="small"
          />
        </div>
        <div class="strategy-row flex row justify-center items-center">
          <div class="w-[5%] bullet"> &#9679; </div>
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['strategy3']"
            [parentFormGroup]="form"
            class="w-[95%] strategy-input"
            controlName="strategy3"
            placeholder="Type here"
            type="small"
          />
        </div>
      </div>
      <div
        class="participant-reward-section sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]"
      >
        <div
          *ngIf="sessionNumber <= 8"
          class="title bold-text"
        >
          When I meet my weekly goals, we will recognize my achievement this
          way:
        </div>
        <div
          *ngIf="sessionNumber >= 9 && sessionNumber <= 16"
          class="title bold-text"
        >
          When I meet my weekly goals, we will recognize my achievement this
          way:
        </div>
        <div
          *ngIf="sessionNumber >= 17 && sessionNumber <= 26"
          class="title bold-text"
        >
          When I meet my weekly goals, we will recognize my achievement this
          way:
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['participantReward']"
          [parentFormGroup]="form"
          class="reward-input"
          controlName="participantReward"
          placeholder="Type here"
          type="small"
        />
      </div>
      <hr class="hr w-full" />
      <div
        class="declaration-text w-full bold-text inline align-middle sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]"
      >
        By completing this contract, I
        <span class="participant-name">
          {{
            form?.controls["adultSignatureText"].value ||
              form?.controls["adultName"].value
          }}
        </span>
        <span
          *ngIf="
            !form?.controls['adultSignatureText'].value &&
            !form?.controls['adultName'].value
          "
          class="no-adult-name"
        ></span>
        <span
          *ngIf="sessionNumber <= 8"
          class="title bold-text"
        >
          , commit to helping my child achieve their weekly goals by supporting
          them with the following
          <span class="underline">support strategies </span>:
        </span>
        <span
          *ngIf="sessionNumber >= 9 && sessionNumber <= 16"
          class="title bold-text"
        >
          , commit to helping my child achieve their weekly goals by supporting
          them with the following
          <span class="underline">support strategies </span>:
        </span>
        <span
          *ngIf="sessionNumber >= 17 && sessionNumber <= 26"
          class="title bold-text"
        >
          , commit to helping my child achieve their weekly goals by supporting
          them with the following
          <span class="underline">support strategies </span>:
        </span>
      </div>
      <div
        class="adult-support-section flex svc-flex-column gap-[0.5rem] sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]"
      >
        <ng-container *ngIf="sessionNumber >= 4">
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support1']"
            [parentFormGroup]="form"
            class="support1 checkbox"
            controlName="support1"
            label="Meet with my child every day to review their journal."
          ></app-check-box-input>
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support2']"
            [parentFormGroup]="form"
            class="support2 checkbox"
            controlName="support2"
            label="Keep red light foods and beverages out of our home."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support3']"
            [parentFormGroup]="form"
            class="support3 checkbox"
            controlName="support3"
            label="No fast food meals this week."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support4']"
            [parentFormGroup]="form"
            class="support4 checkbox"
            controlName="support4"
            label="Prepare meals with fewer red light ingredients."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support5']"
            [parentFormGroup]="form"
            class="support5 checkbox"
            controlName="support5"
            label="Offer fewer red light options at meals."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support6']"
            [parentFormGroup]="form"
            class="support6 checkbox"
            controlName="support6"
            label="Make green light snacks easy to see and eat."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support7']"
            [parentFormGroup]="form"
            class="support7 checkbox"
            controlName="support7"
            label="Model journaling and reducing my red light food servings along with my child."
          />
        </ng-container>
        <ng-container *ngIf="sessionNumber >= 9">
          <div class="section-spacer"></div>
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support8']"
            [parentFormGroup]="form"
            class="support8 checkbox"
            controlName="support8"
            label="Help my child identify ways to increase their physical activity during the week."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support9']"
            [parentFormGroup]="form"
            class="support9 checkbox"
            controlName="support9"
            label="Plan something active together with my child one or more days this week."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support10']"
            [parentFormGroup]="form"
            class="support10 checkbox"
            controlName="support10"
            label="Model journaling and increasing my daily exercise along with my child."
          />
        </ng-container>
        <div class="section-spacer"></div>
        <ng-container *ngIf="sessionNumber >= 17">
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [parentFormGroup]="form"
            class="support11 checkbox"
            controlName="support11"
            label="No TV, phones or other screens while eating."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support12']"
            [parentFormGroup]="form"
            class="support12 checkbox"
            controlName="support12"
            label="Keep TV, phones and other screens out of bedrooms."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support13']"
            [parentFormGroup]="form"
            class="support13 checkbox"
            controlName="support13"
            label="Establish screen-free time periods."
          />
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['support14']"
            [parentFormGroup]="form"
            class="support14 checkbox"
            controlName="support14"
            label="Model journaling and reducing my screen time along with my child."
          />
        </ng-container>
        <div
          class="other-row w-full flex xs:flex-col sm:flex-row justify-center items-center gap-[1rem]"
        >
          <app-check-box-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['supportOther']"
            [parentFormGroup]="form"
            class="flex supportOther checkbox xs: w-full sm:w-[20%]"
            controlName="supportOther"
            label="Other:"
          />
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['supportOtherText']"
            [parentFormGroup]="form"
            class="flex-grow support-other-text xs:w-full"
            controlName="supportOtherText"
            placeholder="Type here"
            type="small"
          />
        </div>
      </div>
      <div
        class="adult-reward-section sm:px-[2rem] md:px-[5rem] lg:px-[8.2rem]"
      >
        <div class="title bold-text">
          When I achieve my supportive actions, we will recognize my efforts
          this way:
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['adultReward']"
          [parentFormGroup]="form"
          class="reward-input"
          controlName="adultReward"
          placeholder="Type here"
          type="small"
        ></app-text-input>
      </div>
      <hr class="hr w-full" />
      <div
        class="signature-section w-full flex flex-col sm:flex-row justify-center items-center lg:gap-[25rem] sm:gap-[5rem] xs:gap-[5rem]"
      >
        <div
          class="child-signature flex flex-col justify-center items-center xs:w-full sm:w-[50%] md:w-[40rem]"
        >
          <div class="sub-row w-full flex flex-row gap-[1rem]">
            <app-check-box-input
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['childSignature']"
              [parentFormGroup]="form"
              class="child-signature-checkbox xs:w-[20%] sm:w-[10%]"
              controlName="childSignature"
            />
            <app-text-input
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['childSignatureText']"
              [ngClass]="{
                'child-signature-error-text':
                  !errorMessages['childSignatureText'],
              }"
              [parentFormGroup]="form"
              class="w-full flex-grow child-signature-text xs:mt-0 sm:mt-[-0.5rem]"
              controlName="childSignatureText"
            />
          </div>
          <div class="sub-row w-full bold-text label">
            Participant Signature
          </div>
        </div>
        <div
          class="adult-signature flex flex-col justify-center items-center xs:w-full sm:w-[50%] md:w-[40rem]"
        >
          <div class="sub-row w-full flex flex-row gap-[1rem]">
            <app-check-box-input
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['adultSignature']"
              [parentFormGroup]="form"
              class="adult-signature-checkbox xs:w-[20%] sm:w-[10%]"
              controlName="adultSignature"
            />
            <app-text-input
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['adultSignatureText']"
              [parentFormGroup]="form"
              [ngClass]="{
                'parent-signature-error-text':
                  !errorMessages['adultSignatureText'],
              }"
              class="w-full flex-grow parent-signature-text mt-[-0.5rem]"
              controlName="adultSignatureText"
            />
          </div>
          <div class="sub-row w-full bold-text label"> Adult Signature </div>
        </div>
      </div>
      <hr class="hr w-full" />
      <div
        class="action-section flex flex-row justify-end items-center gap-[1rem]"
      >
        <app-primary-button
          (handleClick)="continue()"
          class="edit-button sm:w-[15rem] xs:w-full"
          type="small"
        >
          Save
        </app-primary-button>
        <app-primary-button
          (handleClick)="cancel()"
          class="edit-button sm:w-[15rem] xs:w-full"
          type="small"
        >
          Cancel
        </app-primary-button>
      </div>
    </ng-container>
  </mat-card>
</div>
